import React, { Component } from "react";
import { HiExternalLink } from "react-icons/hi";
import sampleimage from './sampleimage.png';
import { IoMdArrowRoundBack } from "react-icons/io";
import { IoMdArrowRoundForward } from "react-icons/io";
import logo from './logo.png';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";

class AuctionCollections extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let creatorAddress = this.props.collectionDetails.creatorAddress;

    // TODO undo immigrant parents hard coding

    return (
      <div className="h-128 justify-center flex flex-col">
        {
          this.props.collectionDetails.latestAuction != null && this.props.collectionDetails.latestAuction.mediaType !== 2
            ?
          <video className="w-96 h-96 object-cover rounded-lg cursor-pointer" src={
            this.props.collectionDetails.latestAuction.animation_url
          }
          controls
          muted="muted"
          autoplay="autoplay"
          onClick={() => {
            loggingUtils.logEvent(
              this.props.account != null
                ? this.props.account.address
                : encryptUtils.getWalletUnconnectedUserId(),
              "auction_collections_page",
              "auction_collections_page_click_auction",
              "info",
              "https://the402.xyz",
              {}
            );
            window.location.href = window.location.origin + "/auction/" + this.props.collectionDetails.id;
          }} />
            :
          <img className="w-96 h-96 object-cover rounded-lg cursor-pointer" src={
            this.props.collectionDetails.latestAuction != null
              ?
            this.props.collectionDetails.latestAuction.imagePinata
              :
            logo
          }
          onClick={() => {
            loggingUtils.logEvent(
              this.props.account != null
                ? this.props.account.address
                : encryptUtils.getWalletUnconnectedUserId(),
              "auction_collections_page",
              "auction_collections_page_click_auction",
              "info",
              "https://the402.xyz",
              {}
            );
            window.location.href = window.location.origin + "/auction/" + this.props.collectionDetails.id;
          }} />
        }
        <div className="text-lg font-medium mt-2 text-black dark:text-white">
          {
            this.props.collectionDetails.latestAuction != null
              ?
            this.props.collectionDetails.latestAuction.name.includes("Immigrant Parents")
              ?
            "Immigrant Parents (live with the402)"
              :
            this.props.collectionDetails.latestAuction.name
              :
            "Not yet started"
          }
        </div>
        <div className="flex items-center cursor-pointer text-md font-medium text-gray-500 dark:text-zinc-500">
          {creatorAddress.substring(0, 5) + "..." + creatorAddress.substring(creatorAddress.length - 5)}
          <HiExternalLink onClick={() => {
            loggingUtils.logEvent(
              this.props.account != null
                ? this.props.account.address
                : encryptUtils.getWalletUnconnectedUserId(),
              "auction_collections_page",
              "auction_collections_page_visit_creator_link",
              "info",
              "https://the402.xyz",
              {}
            );
            window.open("https://etherscan.io/address/" + creatorAddress, "_blank");
          }} />
        </div>
      </div>
    );
  }
}

export default AuctionCollections;
